// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class IntakeHcpIntakeDefaultResponse {
    static getAttributeTypeMap() {
        return IntakeHcpIntakeDefaultResponse.attributeTypeMap;
    }
}
IntakeHcpIntakeDefaultResponse.discriminator = undefined;
IntakeHcpIntakeDefaultResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "HcpIntakeResponseModel"
    }
];
//# sourceMappingURL=intakeHcpIntakeDefaultResponse.js.map